import { Component, Inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Router } from '@angular/router';
import { SpinnerService } from '../../../services/spinner.service';
import { DownloadService } from '../../../services/download.service';
import { SnackbarService } from '../../../services/snackbar.service';
import {
  AportacionDIEstadoControllerService,
  OperacionGestionControllerService,
  ResiduoEnvaseFilterDTO,
  SolicitudNimaGestoresDTO,
  AportacionDIEstadoDTO,
  GestoresResiduosControllerService,
  CodigoOperacionFilterDTO,
  CodigoLerFilterDTO,
  CodigoLerControllerService,
  AportacionDisddrcaControllerService,
  AportacionDISDDRCADTO,
  EntidadAsociadaDTO,
  IdEntityDTO,
  AportacionDIPoseedorControllerService,
  ComprobarSolicitudRequestDTO,
  SolicitudCodigoLerDTO, GestionResiduosFilterDTO, AutocompletarDatosGestorDTO, AportacionDISDDRCAPayloadDTO
} from 'api-rest';
import { debounceTime, Observable, Subscription, tap } from 'rxjs';
import { EmpusaAuthenticationService } from '@empusa/empusa-core';
import { DocumentService } from '../../../services/document.service';
import moment from 'moment';
import { OpenSddrContributionsDisImageDialogComponent } from '../open-sddr-contributions-dis-image-dialog/open-sddr-contributions-dis-image-dialog.component';
import swal from 'sweetalert2';
import { OpenSddrContributionsDisDeclineDialogComponent } from '../open-sddr-contributions-dis-cancel-dialog/open-sddr-contributions-dis-cancel-dialog.component';
import { OpenSddrContributionsDisPreviewDialogComponent } from '../open-sddr-contributions-dis-preview-dialog/open-sddr-contributions-dis-preview-dialog.component';
import { ValidateService } from '../../../services/validate.service';

@Component({
  selector: 'app-open-sddr-contributions-dis-dialog',
  templateUrl: './open-sddr-contributions-dis-dialog.component.html',
  styleUrls: ['./open-sddr-contributions-dis-dialog.component.scss'],
})
export class OpenSddrContributionsDisDialogComponent implements OnInit {
  estadoArray: AportacionDIEstadoDTO[] = [];
  codigoLerArray: any[] = [];
  //residuoArray: any[] = [];
  gestionArray: any[] = [];
  //nimaGestorArray: any[] = [];
  //nimaPoseedorArray: any[] = [];
  //entityRoles: any[] = [];

  modelForm!: FormGroup;
  subscriptions: Subscription[] = [];
  roleEntities: any[] = [];
  documento: File | undefined;
  titulo: any;
  isGestor = false;
  //isPoseedor = false;
  edicion = false;
  alta = false;
  estado: Number = 1;
  usuarioSddrCa: any = null;
  cargaCombos:boolean = true;

  pageNumber: number = 0;
  pageSize: number = 100;
  recordsTotal: number = 0;

  operacionGestionEndpoint: string = this.environment.urlBackCore + `api/v1/poseedores/operacion-gestion/codigo-operacion`;
  updateList: boolean = false;
  defaultOperacionesGestionParameters: any = {codigoLer: [null], poseedores: true};

  get styleEstadoAportaciones(): { [key: string]: string } {
    const estadoId = this.aportacion?.estado?.id;
    switch (estadoId) {
      case 2: return { 'background-color': '#F49D33', 'color': '#ffffff' };
      case 3: return { 'background-color': '#86BC25', 'color': '#ffffff' };
      case 4: return { 'background-color': '#773E90', 'color': '#ffffff' };
      case 5: return { 'background-color': '#A7A6A6', 'color': '#ffffff' };
      case 6: return { 'background-color': '#5FC3E1', 'color': '#ffffff' };
      case 7: return { 'background-color': '#B80F61', 'color': '#ffffff' };
      case 8: return { 'background-color': '#080C35', 'color': '#ffffff' };
      case 9: return { 'background-color': '#004A99', 'color': '#ffffff' };
      default: return { 'background-color': '#ffffff', 'color': '#080C35' };
    }
  }
    get iconEstado() {
    return this.aportacion?.estado?.id === 3 ? 'check_circle' : 'warning_amber';
  }

  constructor(
    @Inject('environment') private environment: any,
    private formBuilder: FormBuilder,
    private router: Router,
    public dialog: MatDialog,
    public spinnerSrv: SpinnerService,
    private snackBarSrv: SnackbarService,
    private dialogRef: MatDialogRef<OpenSddrContributionsDisDialogComponent>,
    private estadoAportacionesService: AportacionDIEstadoControllerService,
    private aportacionDisddrcaCtrSrv: AportacionDisddrcaControllerService,
    private aportacionDisPoseedorCtrSrv: AportacionDIPoseedorControllerService,
    private codigoLerService: CodigoLerControllerService,
    private gestorResiduosService: GestoresResiduosControllerService,
    private downloadService: DownloadService,
    private documentService: DocumentService,
    @Inject('EmpusaAuthenticationService')
    private authService: EmpusaAuthenticationService,
    @Inject(MAT_DIALOG_DATA) public aportacion: AportacionDISDDRCADTO | any,
    private operacionGestionControllerService: OperacionGestionControllerService,
    private validateSrv: ValidateService,
  ) {
    //Las aportaciones del sddr ca por el modulo del sddr ca siempre las va a crear el acondicionador
    this.isGestor = true;
    this.inicializarForm();
    this.defaultOperacionesGestionParameters = {codigoLer: [this.modelForm.get('codigoLer')?.value?.id ?? null], poseedores: true};
  }

  ngOnInit() {

    if (this.aportacion?.acondicionador) {
      this.spinnerSrv.loadingShow();
      const peticionInicial = this.buscarInicialGestor();
      peticionInicial.subscribe({
        next: () => {
          this.cargaInicial();
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
    } else {
      this.cargaInicial();
    }

  }

  inicializarForm() {
    this.aportacion.fechaAceptacion = this.aportacion.fechaAceptacion ?? new Date().toISOString();
    if(this.aportacion.acondicionador == null && this.aportacion.nimaAcondicionador != null && this.aportacion.nimaAcondicionador != ''){
      this.aportacion.acondicionador = {
        nima: this.aportacion.nimaAcondicionador
      }
    }
    this.modelForm = this.formBuilder.group({
      id: [{ value: this.aportacion?.id }],
      //idSolicitud: [{ value: this.aportacion?.solicitudRetirada?.id, disabled: false },],
      //usuarioSddrCa: [{ value: null, disabled: false },],
      //nimaRazonGestor: [{ value: null, disabled: false },],
      nimaRazonAcondicionador: [{ value: null, disabled: false },],
      esCreadoPoseedor: [{ value: false, disabled: false },],
      documentoIdentificacion: [
        { value: this.aportacion?.documentoIdentificacion, disabled: false },
        { validators: Validators.compose([Validators.required, Validators.maxLength(255)]) },
      ],
      fechaAceptacion: [
        { value: this.aportacion?.fechaAceptacion, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      fechaAportacion: [
        { value: this.aportacion?.fechaAportacion, disabled: true },
      ],
      estado: [{ value: this.aportacion?.estado, disabled: false }],

      nimaGestor: [
        { value: this.aportacion?.gestorResiduo ? this.aportacion?.gestorResiduo?.nima : this.aportacion?.nimaGestor, 
          disabled: false },
        { validators: Validators.compose([Validators.required, Validators.pattern(this.validateSrv.nimaPattern)]) },
      ],
      documentoGestor: [
        { value: this.aportacion?.gestorResiduo ? this.aportacion?.gestorResiduo?.codigoDocumento : this.aportacion?.documentoGestor, 
          disabled: false },
        { validators: Validators.compose([Validators.required, Validators.maxLength(15), Validators.pattern(this.validateSrv.nifPattern)]) }],
      razonSocialGestor: [
        { value: 
          this.aportacion?.gestorResiduo ? this.aportacion?.gestorResiduo?.razonSocial : this.aportacion?.razonSocialGestor, 
          disabled: true },
        { validators: Validators.compose([Validators.required, Validators.maxLength(255)]) }],
      idGestor: [
        { value: this.aportacion?.gestorResiduo?.id, disabled: true }],
      nimaAcondicionador: [
        { value: this.aportacion?.acondicionador, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      autofactura: [{ value: null, disabled: false }],
      documento: [{ value: this.aportacion?.documento, disabled: false }],
      codigoLer: [
        { value: this.aportacion?.codigoLer, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],
      //gestorResiduo: [
      //  { value: this.aportacion?.gestorResiduo, disabled: false },
      //],
      operacionGestion: [
        { value: this.aportacion?.operacionGestion, disabled: false },
        { validators: Validators.compose([Validators.required]) },
      ],

      cantidadGestionada: [
        { value: this.aportacion?.cantidadGestionada, disabled: false },
        { validators: Validators.compose([Validators.required, Validators.min(0.000000001)]) },
      ],
    });

    ////if(this.isGestor){
    //this.modelForm.get('idSolicitud')?.setValidators(Validators.compose([Validators.required, Validators.pattern('^[0-9]+$'), Validators.maxLength(10)]));
    //this.modelForm.get('usuarioSddrCa')?.setValidators([Validators.required]);
    ////}

    //this.valueChangeCodigoLer();

    //// Set valor usuario poseedor o adherido (edit)
    //if (this.aportacion?.solicitudRetirada?.adherido || this.aportacion?.solicitudRetirada?.poseedor) {
    //  const tipoUsuario = this.aportacion?.solicitudRetirada?.adherido ? 'AD - ' : this.aportacion?.solicitudRetirada?.poseedor ? 'PO - ' : '';
    //  this.usuarioSddrCa = this.aportacion?.solicitudRetirada?.adherido || this.aportacion?.solicitudRetirada?.poseedor || null;
    //  this.modelForm.patchValue({
    //    usuarioSddrCa: tipoUsuario + this.usuarioSddrCa?.razonSocial,
    //  });
    //}
  }

  //assignEvents(){
  //  const sub3 = this.modelForm.controls['nimaGestor'].valueChanges.subscribe(
  //    (val) => {
  //      this.buscaCodigoLer(
  //        this.modelForm.value?.fechaAceptacion,
  //        val,
  //      );
  //    }
  //  );
  //  this.subscriptions.push(sub3);
  //}

  cargaInicial() {
    this.roleEntities = (this.authService.user as any).roleEntities;
    if (this.aportacion?.id) {
      this.titulo = 'Editar aportación de DI/FS';
      this.edicion = true;
    } else {
      this.titulo = 'Alta de aportación de DI/FS';
      this.edicion = false;

      //if (this.isPoseedor) {
      //  this.modelForm.patchValue({
      //    usuarioSddrCa: 'PO - ' + this.aportacion.poseedor?.razonSocial,
      //  });
      //}
      if(this.isGestor){
        const acondicionador = this.modelForm.get('nimaAcondicionador')?.value;
        this.modelForm.patchValue({
          nimaRazonAcondicionador: acondicionador?.nima + " - " + acondicionador?.razonSocial,
        });
      }
    }

    this.cargaCombos = true;
    if (!this.canSaveAll()) {
      this.modelForm.patchValue({
        nimaRazonAcondicionador: this.aportacion?.acondicionador?.nima + " - " + this.aportacion?.acondicionador?.razonSocial,
      });
      this.modelForm.disable();
      this.cargaCombos = false;
    } 
    //else {
    //  this.buscarSolicitudRetirada();
    //}

    this.estadoAportacionesService.findAll14().subscribe((estados) => (this.estadoArray = estados));
    if(this.cargaCombos){
      if(this.edicion){
        this.buscarOperacionesGestion();
      }
      //this.buscarNimaGestor();
      this.buscaCodigoLer(
        this.modelForm.value?.fechaAceptacion,
        this.aportacion.acondicionador,
      );
    }else{
      //La aportacion no se va a editar, por lo que no tiene sentido cargar los combos con todos los datos disponibles
      //Se cargan los datos con lo que tiene el detalle
      if(this.aportacion?.codigoLer){
        this.codigoLerArray.push(this.aportacion?.codigoLer);
        this.setItemSelected('codigoLer', 'id', this.codigoLerArray);
      }
      if(this.aportacion?.operacionGestion){
        this.gestionArray.push(this.aportacion?.operacionGestion);
        this.setItemSelected('operacionGestion', 'id', this.gestionArray);
      }

    }
    
    this.updateDisableField('documentoIdentificacion');
    this.updateDisableField('fechaAceptacion');
    this.updateDisableField('cantidadGestionada');

    if(this.cargaCombos){
      //this.assignEvents();
      this.valueChangeCodigoLer();
      this.valueChangeNimaGestor();
    }

  }

  buscarInicialGestor(): Observable<any> {
    return this.gestorResiduosService
      .getById3(this.aportacion?.acondicionador?.id)
      .pipe(
        tap((res) => {
          this.aportacion.acondicionador = res;
        })
      );
  }

  updateDisableField(field: any): void {
    if (this.aportacion.estado) {
      if (!this.canAccessEditEstado()) {
        this.modelForm.get(field)?.disable();
      }
    }
  }

  //buscarNimaGestor() {
  //  if (this.aportacion?.poseedor) {
  //    //const filtroNimaGestor: SolicitudNimaGestoresDTO = {
  //    //  fechaAceptacion: this.modelForm.value?.fechaAceptacion,
  //    //  poseedor: this.aportacion?.poseedor,
  //    //};
  //    //this.spinnerSrv.loadingShow();
  //    //this.aportacionDisPoseedorCtrSrv.nimaGestores(filtroNimaGestor).subscribe({
  //    //  next: (res) => {
  //    //    this.nimaGestorArray = res;
  //    //    if (this.isPoseedor) {
  //    //      this.nimaGestorArray = this.nimaGestorArray.filter((item: any) => item.id);
  //    //    }
  //    //    this.setItemSelected('nimaGestor', 'id', this.nimaGestorArray);
  //    //    this.spinnerSrv.loadingHide();
  //    //  },
  //    //  error: () => {
  //    //    this.spinnerSrv.loadingHide();
  //    //  },
  //    //});
  //    //Buscar todos los gestores residuos, no solo los gestores del poseedor
  //    const body: GestionResiduosFilterDTO = {
  //      acondicionadorEnvase: true
  //    }
  //    this.spinnerSrv.loadingShow();
  //    this.gestorResiduosService.findAll8(body, { page: 0, size: 1000 })
  //      .subscribe({
  //        next: (res: any) => {
  //          this.nimaGestorArray = res?.datos ?? [];
  //          this.setItemSelected('nimaGestor', 'id', this.nimaGestorArray);
  //          this.spinnerSrv.loadingHide();
  //        },
  //        error: (error: any) => {
  //          this.spinnerSrv.loadingHide();
  //        },
  //      });
//
  //  } else {
  //    this.spinnerSrv.loadingShow();
  //    this.aportacionDisddrcaCtrSrv.nimaGestores()
  //      .subscribe({
  //        next: (res) => {
  //          this.nimaGestorArray = res;
  //          this.setItemSelected('nimaGestor', 'id', this.nimaGestorArray);
  //          this.spinnerSrv.loadingHide();
  //        },
  //        error: () => {
  //          this.spinnerSrv.loadingHide();
  //        },
  //      });
  //  }
  //}

  buscaCodigoLer(fechaAceptacion: any, acondicionador: any) {
    if (fechaAceptacion && acondicionador) {
      const filtroNimaPoseedor: CodigoLerFilterDTO = {
        acuerdoGestores: true,
        sddrCA: true
      };
      this.spinnerSrv.loadingShow();
      this.aportacionDisddrcaCtrSrv.codigoLer(acondicionador).subscribe({
        next: (res) => {
          this.codigoLerArray = res || [];
          this.setItemSelected('codigoLer', 'id', this.codigoLerArray);
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
    } else {
      this.codigoLerArray = [];
    }
  }

  //buscarGestorResiduos() {
  //  const filtroResiduo: ResiduoEnvaseFilterDTO = {};
  //  this.spinnerSrv.loadingShow();
  //  this.gestorResiduosService
  //    .findAll8(filtroResiduo, { page: 0, size: 1000 })
  //    .subscribe({
  //      next: (res) => {
  //        this.residuoArray = res?.datos ?? [];
  //        this.setItemSelected('gestorResiduo', 'id', this.residuoArray);
  //        this.updateDisableField('gestorResiduo');
  //        this.spinnerSrv.loadingHide();
  //      },
  //      error: () => {
  //        this.spinnerSrv.loadingHide();
  //      },
  //    });
  //}

  valueChangeCodigoLer() {
    this.modelForm.get('codigoLer')?.valueChanges.subscribe((value: any) => {
      if (value) {
        this.defaultOperacionesGestionParameters = {codigoLer: [value?.id ?? null], poseedores: true};
        this.updateList = !this.updateList;
        this.buscarOperacionesGestion();
      } else {
        this.defaultOperacionesGestionParameters = {codigoLer: [null], poseedores: true};
        this.modelForm.controls['operacionGestion'].reset();
        this.gestionArray = [];
      }
    });
  }

  valueChangeNimaGestor() {
    this.modelForm.get('nimaGestor')?.valueChanges.subscribe((value: string) => {
      //if (value && value.length === 10) {
        // this.buscarGestor();
      //}
    });
  }

  buscarOperacionesGestion() {
    const { backendFilter, page, size } = this.getBackendFilter();
    this.spinnerSrv.loadingShow();
    this.operacionGestionControllerService
      .findByCodigoOperacion(backendFilter, { page: page, size: size })
      .subscribe({
        next: (res) => {
          if (res) {
            this.gestionArray = res?.datos ?? [];
            this.setItemSelected('operacionGestion', 'id', this.gestionArray);
            this.updateDisableField('operacionGestion');
          }
          this.spinnerSrv.loadingHide();
        },
        error: () => {
          this.spinnerSrv.loadingHide();
        },
      });
  }

  private getBackendFilter() {
    const backendFilter: CodigoOperacionFilterDTO = {
      codigoLer: [this.modelForm.get('codigoLer')?.value?.id],
      sddrca: true
    };
    const page = this.pageNumber <= 1 ? 0 : this.pageNumber - 1;

    return { backendFilter, page, size: this.pageSize };
  }

  private setItemSelected(
    controlName: string,
    propertyName: string,
    items: any[]
  ) {
    let selectedItem = null;
    if (this.modelForm.value[controlName]) {
      if (
        typeof this.modelForm.value[controlName] == 'object' &&
        this.modelForm.value[controlName][propertyName]
      ) {
        selectedItem = items.find(
          (item) =>
            this.modelForm.value[controlName][propertyName] ==
            item[propertyName]
        );
      } else {
        selectedItem = items.find(
          (item) => this.modelForm.value[controlName] == item[propertyName]
        );
      }
    }
    this.modelForm.controls[controlName].patchValue(selectedItem, {
      emitEvent: false,
    });
  }

  closeDialog(): void {
    this.dialogRef.close();
  }

  buttonSaveData(estadoId: any) {
    this.modelForm.markAllAsTouched();
    this.modelForm.updateValueAndValidity();

    if (this.aportacion?.documento == null) {
      if (this.documento == undefined || this.documento == null) {
        this.snackBarSrv.showSnackBar('Adjunte documento', 'error');
        return;
      }
    }

    if (this.modelForm.valid) {
      const todayDate = new Date();
      const fechaAceptacion = new Date(this.modelForm.get('fechaAceptacion')?.value);
      if(fechaAceptacion > todayDate){
        this.snackBarSrv.showSnackBar(
          'La fecha de aceptación no puede ser posterior a la fecha actual.',
          'error'
        );
        return;
      }
      const cantidadGest = this.modelForm.get('cantidadGestionada')?.value;
      if(cantidadGest && cantidadGest < 100){
        swal.fire({
          text: 'Por favor, verifique que el valor introducido en la cantidad neta gestionada es correcto y está en las unidades correspondientes (Kg)',
          icon: 'question',
          showDenyButton: true,
          showCancelButton: false,
          confirmButtonText: 'Guardar',
          denyButtonText: 'Cancelar',
          allowOutsideClick: false,
        }).then((result: any) => {
          if (result.isConfirmed) {
            this.saveData(estadoId);
          }
        });
      }else{
        this.saveData(estadoId);
      }
    }
  }

  saveData(estadoId: any) {
    const formValue = this.modelForm.value;
    const aportacionPayload: AportacionDISDDRCAPayloadDTO = formValue;

    //aportacionPayload.gestorResiduo = formValue.nimaGestor;
    if (aportacionPayload.estado !== undefined && estadoId !== null) {
      aportacionPayload.estado.id = estadoId;
    }
    aportacionPayload.acondicionador = {id: this.aportacion.acondicionador.id};
    if(this.modelForm.get('idGestor')?.value){
      aportacionPayload.gestorResiduo = {id: this.modelForm.get('idGestor')?.value};
    }else{
      aportacionPayload.nimaGestor = this.modelForm.get('nimaGestor')?.value;
      aportacionPayload.razonSocialGestor = this.modelForm.get('razonSocialGestor')?.value;
      aportacionPayload.documentoGestor = this.modelForm.get('documentoGestor')?.value;
    }
    
    aportacionPayload.fechaAceptacion = moment(aportacionPayload.fechaAceptacion).format('YYYY-MM-DD');
    aportacionPayload.esCreadoPoseedor = false;
    let request, successMsg: string, errorMsg: string;
    if (this.aportacion?.id) {
      request = this.aportacionDisddrcaCtrSrv
        .editById5(
        this.aportacion.id,
        aportacionPayload,
        this.documento
      );
      successMsg = 'La aportación DI/FS se ha editado correctamente';
      errorMsg = 'Ha ocurrido un error al editar la aportación DI/FS';
    } else {
      if (!this.documento) {
        this.snackBarSrv.showSnackBar(
          'Debe seleccionar un documento',
          'error'
        );
        return;
      }

      request = this.aportacionDisddrcaCtrSrv.create5(
        aportacionPayload,
        this.documento
      );
      successMsg = 'La aportación DI/FS se ha creado correctamente';
      errorMsg = 'Ha ocurrido un error al crear la nueva aportación DI/FS';
    }
    this.spinnerSrv.loadingShow();
    request.subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.dialogRef.close(true);
        this.snackBarSrv.showSnackBar(successMsg, 'success');
      },
      error: () => {
        this.aportacion.estado.id = 1;
        this.spinnerSrv.loadingHide();
      },
    });
  }

  showClearButton(formName: string): boolean {
    return this.modelForm.get(formName)?.value !== null;
  }

  clearSelection(event: Event, formName: string) {
    event.stopPropagation();
    this.modelForm.get(formName)?.setValue(null);
  }

  controlHasError(controlName: string, errorName: string) {
    return (
      this.modelForm.controls[controlName].hasError(errorName) &&
      this.modelForm.controls[controlName].touched
    );
  }

  attachAdjunto(archivo: File | null): void {
    if (archivo) {
      if (archivo.size === 0) {
        this.snackBarSrv.showSnackBar(
          'No se puede subir un fichero vacío',
          'error'
        );
      } else if (archivo.size > 12 * 1024 * 1024) { // 5 MB
        this.snackBarSrv.showSnackBar(
          'El fichero supera el tamaño máximo permitido de 12 MB',
          'error'
        );
      } else {
        this.documento = archivo;
      }
    }
  }

  descargar(documento: any) {
    this.spinnerSrv.loadingShow();
    this.documentService.descargarDocumento(documento.id).subscribe({
      next: (response) => {
        this.spinnerSrv.loadingHide();
        this.snackBarSrv.showSnackBar(
          'Se ha descargado el documento correctamente',
          'success'
        );
        this.downloadService.downloadBlob(response, documento.nombre);
      },
      error: () => {
        this.spinnerSrv.loadingHide();
      },
    });
  }

  canAccessEditEstado(): boolean {
    return this.aportacion?.estado?.id === 1;
  }

  canAccessEditByRol(): boolean {
    return this.authService.can('sddr-ca-di-detalle', 'access-update');
  }

  canViewResource(rol: string): boolean {
    return this.authService.hasCurrentUserRole(rol);
  }

  canSaveAll(): boolean {
    if ((this.canAccessEditByRol() || this.canViewResource('PO-GESTOR')) && this.canAccessEditEstado()) {
      if (
        this.edicion &&
        this.aportacion.creadoPor == this.authService.getCurrentUserMail()
      ) {
        return true;
      } else if (!this.edicion) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  //buscarSolicitudRetirada() {
  //  if (this.modelForm.get('idSolicitud')?.value) {
  //    const idSolicitud = this.modelForm.get('idSolicitud')?.value;
  //    const gestorSel = this.modelForm.get('nimaGestor')?.value;
//
  //    if (!idSolicitud) {
  //      return this.resetUsuarioSddrCa()
  //    }
  //    this.spinnerSrv.loadingShow();
  //    let filter: ComprobarSolicitudRequestDTO =
  //    {
  //      idSolicitud: idSolicitud,
  //    };
  //    if (this.isGestor) {
  //      filter.idGestor = this.aportacion?.gestorResiduo ? this.aportacion?.gestorResiduo?.id : gestorSel?.id;
  //    }
  //    if (this.isPoseedor) {
  //      filter.idPoseedor = this.aportacion?.poseedor?.id;
  //    }
  //    this.aportacionDisddrcaCtrSrv.comprobarSolicitud(filter)
  //      .subscribe({
  //        next: (res: any) => {
  //          this.spinnerSrv.loadingHide();
  //          if(res.solicitudEstadoIncorrecto != null && res.solicitudEstadoIncorrecto){
  //            this.snackBarSrv.showSnackBar('Solo se pueden realizar aportaciones asociadas a retiradas en estado Aceptada y Prefacturada.', 'warning');
  //          }else{
  //            if (this.isGestor) {
  //              const tipoUsuario = res.adherido ? 'AD - ' : res.poseedor ? 'PO - ' : '';
  //              if (!tipoUsuario) {
  //                return this.showSolicitudError();
  //              }
  //              this.usuarioSddrCa = res.adherido || res.poseedor || null;
  //              this.modelForm.patchValue({
  //                usuarioSddrCa: tipoUsuario + this.usuarioSddrCa?.razonSocial,
  //              });
//
  //              this.modelForm.patchValue({
  //                nimaRazonGestor: this.aportacion?.gestorResiduo?.nima + " - " + this.aportacion?.gestorResiduo?.razonSocial,
  //              });
//
  //            } else {
  //              //Si es poseedor, seleccionar el nima gestor de la respuesta
  //              //const idGestor = res.gestorResiduos.id;
  //              //this.modelForm.get('nimaGestor')?.setValue(this.nimaGestorArray.filter((item:any) => item.id === idGestor)[0]);
  //              this.modelForm.get('nimaGestor')?.setValue(res.gestorResiduos);
  //              //const gestor = this.modelForm.get('nimaGestor')?.value
  //              this.modelForm.patchValue({
  //                nimaRazonGestor: res.gestorResiduos?.nima + " - " + res.gestorResiduos?.razonSocial,
  //              });
  //            }
  //          }
  //        },
  //        error: () => {
  //          this.spinnerSrv.loadingHide();
  //          this.showSolicitudError();
  //        },
  //      });
  //  }
  //}

  //private showSolicitudError() {
  //  this.snackBarSrv.showSnackBar(
  //    'Este usuario no tiene permiso para seleccionar esta ID Solicitud Retirada.',
  //    'warning'
  //  );
  //  this.resetUsuarioSddrCa();
  //}
//
  //private resetUsuarioSddrCa() {
  //  this.usuarioSddrCa = null;
  //  this.modelForm.patchValue({
  //    usuarioSddrCa: null,
  //  });
  //}

  onlyNumberKey(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'ArrowLeft', 'ArrowRight', 'Tab', 'Delete', 'Control'];

    if (event.ctrlKey && (event.key === 'c' || event.key === 'v')) return;

    // Permitir números y teclas adicionales definidas
    if (!/^[0-9]$/.test(event.key) && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  openModalAyuda(){
    const dialogRef = this.dialog.open(
        OpenSddrContributionsDisImageDialogComponent,
        {
          width: '98%',
          maxWidth: '98%',
          maxHeight: '95vh',
          disableClose: true,
        }
      );

      dialogRef.afterClosed().subscribe((result) => {
      });
  }

  buscarGestor() {
    if(this.modelForm.get('nimaGestor')?.value && this.modelForm.get('nimaGestor')?.value.length == 10
     || this.modelForm.get('documentoGestor')?.value){
          const filtroResiduo: AutocompletarDatosGestorDTO = {
            nima : this.modelForm.get('nimaGestor')?.value,
            codigoDocumento : this.modelForm.get('documentoGestor')?.value

      };
  
      this.spinnerSrv.loadingShow();
      this.aportacionDisddrcaCtrSrv
        .autocompletarDatosGestor(filtroResiduo)
        .subscribe({
          next: (res) => {
            if(res){
              this.aportacion.gestorResiduo = res;
              this.modelForm.get('idGestor')?.setValue(this.aportacion.gestorResiduo.id);
              this.modelForm.get('nimaGestor')?.setValue(this.aportacion.gestorResiduo.nima)
              this.modelForm.get('documentoGestor')?.setValue(this.aportacion.gestorResiduo.codigoDocumento);
              this.modelForm.get('razonSocialGestor')?.setValue(this.aportacion.gestorResiduo.razonSocial);
              // this.modelForm.get('documentoGestor')?.disable();
              filtroResiduo.codigoDocumento = undefined;
              filtroResiduo.nima=undefined
              this.modelForm.get('razonSocialGestor')?.disable();
            }else{
              this.snackBarSrv.showSnackBar("El NIMA o el documento de gestor no existe en la base de datos de gestores de ENVALORA. Introduzca un documento y una razón social para el gestor.", "warning");
              this.modelForm.get('documentoGestor')?.enable();
              this.modelForm.get('razonSocialGestor')?.setValue('');
              this.modelForm.get('razonSocialGestor')?.enable();
            }
            this.spinnerSrv.loadingHide();
          },
          error: () => {
            this.spinnerSrv.loadingHide();
          },
        });

    }else{
      this.modelForm.get('idGestor')?.setValue(null);
      this.modelForm.get('nimaGestor')?.setValue(null);
      this.modelForm.get('documentoGestor')?.setValue(null);
      this.modelForm.get('razonSocialGestor')?.setValue(null);

      // this.modelForm.get('documentoGestor')?.disable();
      this.modelForm.get('razonSocialGestor')?.disable();
    }


  }

   canAccessAcceptAportacion(){
    const resultAccept = this.authService.can('acuerdo-indirecto-di', 'update-accept');
    const estado2 = this.aportacion.estado && this.aportacion.estado.id === 2;
    return resultAccept && estado2;
  }

  canAccessCancelAportacion(){
    const resultCancel = this.authService.can('acuerdo-indirecto-di', 'update-cancel');
    const estado2 = this.aportacion.estado && this.aportacion.estado.id === 2;
    return resultCancel && estado2;
  }

  acceptAportacion(){
    this.spinnerSrv.loadingShow();
    this.aportacionDisddrcaCtrSrv
      .aceptarAportacion(this.aportacion.id)
      .subscribe({
        next: () => {
          this.spinnerSrv.loadingHide();
          this.snackBarSrv.showSnackBar(
            'Se ha aceptado la aportación correctamente',
            'success'
          );
          this.dialogRef.close(true);
        },
        error: (err) => {
          this.spinnerSrv.loadingHide();
          console.log(err);
        },
      });
  }

  openModalMotivoCancelAportacion(){
    const dialogRef = this.dialog.open(
      OpenSddrContributionsDisDeclineDialogComponent,
      {
        width: '750px',
        maxWidth: '95%',
        maxHeight: '95vh',
        data: {
          info: this.aportacion,
        },
        disableClose: true,
      }
    );
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.dialogRef.close(true);
      }
    });
  }
  
  vistaPreviaAportacion(element:any){
    const dialogRef = this.dialog.open(OpenSddrContributionsDisPreviewDialogComponent, {
      width: '98%',
      maxWidth: '98%',
      maxHeight: '95vh',
      data: element,
      disableClose: true,
    });
  }

    onInput(controlName: string, event: any) {
    const control = this.modelForm.get(controlName)
    const input = event.target as HTMLInputElement;
    control?.markAsTouched();
    control?.markAsDirty();
  }

  getFormControl(selectForm: any): FormControl {
    switch (selectForm) {
      case 'operacionGestion': {
        return this.modelForm.get('operacionGestion') as FormControl;
      }
      default: {
        return this.modelForm.get('') as FormControl;
      }
    }
  }

  getOperacionesGestionDescription(obj: any) {
    const text = obj.codigo + ' ' + obj.descripcion;
    return text.length > 80 ? text.substring(0, 80) + '...' : text;
  }

  getOperacionesGestionObjectQuery(searchterm: string) {
    return {
      codigoOrDescripcion: `${searchterm}`,
    };
  }
}
